import React from 'react';
import { FaGithub, FaLink } from 'react-icons/fa';

function Portifolio() {
  return (
    <section id="Portifolio" style={styles.container}>
      <h2 style={styles.title}>Meu Portfólio</h2>
      <p style={styles.subtitle}>
        Explore meu portfólio e descubra os projetos que estou desenvolvendo, incluindo o Inova Codigo, um site em constante evolução com foco em inovação, experiência do usuário e design responsivo.
      </p>

      {/* Container de Projetos */}
      <div style={styles.projectsContainer}>
        {/* Card do Projeto 1 */}
        <div style={styles.projectCard}>
          <h3 style={styles.projectTitle}>Inova Codigo</h3>
          <div style={styles.logoContainer}>
            <img 
              src="https://inovacodigo.com.br/img/nome.png" 
              alt="Logo Inovacodigo" 
              style={styles.logo} 
            />
          </div>
          <p style={styles.projectDescription}>
            Este é o projeto atual que estou desenvolvendo. Um site inovador, em React, com foco na experiência do usuário e no design responsivo.
          </p>
          <div style={styles.links}>
            <a href="https://inovacodigo.com.br" target="_blank" rel="noopener noreferrer" style={styles.link}>
              <FaLink size={20} style={styles.icon} /> Visitar Site
            </a>
            <a href="https://github.com/MatheusAvelar/inovacodigo" target="_blank" rel="noopener noreferrer" style={styles.link}>
              <FaGithub size={20} style={styles.icon} /> Ver Código no GitHub
            </a>
          </div>
        </div>

        {/* Card do Projeto 2 */}
        <div style={styles.projectCard}>
          <h3 style={styles.projectTitle}>GitHub</h3>
          <p style={styles.projectDescription}>
            Além do Inovacodigo, no meu GitHub você encontra outros projetos em diversas tecnologias, desde desenvolvimento web até automações e integrações. Confira meu perfil para mais!
          </p>
          <div style={styles.links}>
            <a href="https://github.com/MatheusAvelar" target="_blank" rel="noopener noreferrer" style={styles.link}>
              <FaGithub size={20} style={styles.icon} /> Acessar GitHub
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

const styles = {
  container: {
    backgroundColor: "#f4f4f4",
    textAlign: "center",
  },
  title: {
    fontSize: "36px",
    color: "#333",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "30px",
    lineHeight: "1.6",
    maxWidth: "800px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  projectsContainer: {
    display: "flex",
    justifyContent: "center", // Centraliza os cards horizontalmente
    flexWrap: "wrap", // Permite que os cards quebrem em novas linhas em telas pequenas
    gap: "30px",
    marginTop: "40px", // Distância entre o texto e os cards
  },
  projectCard: {
    backgroundColor: "#fff",
    padding: "25px",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    transition: "transform 0.3s, box-shadow 0.3s",
    cursor: "pointer",
    width: "280px", // Largura fixa para os cards
    maxWidth: "100%", // Faz os cards se ajustarem em telas pequenas
  },
  projectTitle: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  projectDescription: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "20px",
  },
  links: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    marginTop: "auto", // Garante que os links fiquem no final do card
  },
  link: {
    textDecoration: "none",
    color: "#363732",
    fontSize: "15px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: "8px",
    color: "#363732",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center", // Centraliza a logo horizontalmente
    marginBottom: "20px",
  },
  logo: {
    width: "150px", // Ajuste o tamanho da logo conforme necessário
    height: "auto",
  },
};

export default Portifolio;
